const dogTitles = () => {
    const existingTitles = [];

    [].slice.call(document.querySelectorAll('[data-titles]')).forEach((suffix, iteration) => {
        existingTitles.push({
            id: iteration,
            valueTitle: suffix.value,
            valueText: suffix.dataset.titles
        });
    });

    const existingSuffixes = [];

    [].slice.call(document.querySelectorAll('[data-suffixes]')).forEach((suffix, iteration) => {
        existingSuffixes.push({
            id: iteration,
            valueSuffix: suffix.value,
            valueText: suffix.dataset.suffixes
        });
    });

    return {
        dogPrefixes: existingTitles,
        dogPreSuffixes: existingSuffixes,
        valueTitle: '',
        valueText: '',
        valueSuffix: '',
        titleId: existingTitles.length,
        suffixId: existingSuffixes.length,

        addPrefix(event) {
            if (event.target.children.length === 0) return;

            const titleOptions = event.target.children;

            for (let i = 0; i < titleOptions.length; i += 1) {
                const optionText = titleOptions[i].text;
                const optionValue = titleOptions[i].value;

                if (optionValue === this.valueTitle) {
                    this.valueText = optionText;
                }
            }

            if (this.valueText === 'Please select...') return;

            const key = this.dogPrefixes.findIndex((element) => element.valueTitle === this.valueTitle);

            if (key !== -1) {
                this.dogPrefixes.splice(key, 1);
            }

            this.dogPrefixes.push({
                id: this.titleId,
                valueTitle: this.valueTitle,
                valueText: this.valueText
            });

            this.titleId += 1;
        },

        addSuffix(event) {
            if (event.target.children.length === 0) return;

            const suffixOptions = event.target.children;

            for (let i = 0; i < suffixOptions.length; i += 1) {
                const optionText = suffixOptions[i].text;
                const optionValue = suffixOptions[i].value;

                if (optionValue === this.valueSuffix) {
                    this.valueText = optionText;
                }
            }

            if (this.valueText === 'Please select...') return;

            const key = this.dogPreSuffixes.findIndex((element) => element.valueTitle === this.valueTitle);

            if (key !== -1) {
                this.dogPreSuffixes.splice(key, 1);
            }

            this.dogPreSuffixes.push({
                id: this.suffixId,
                valueSuffix: this.valueSuffix,
                valueText: this.valueText
            });

            this.suffixId += 1;
        },

        deletePrefix(id, event) {
            const currentInputValue = event.target.previousElementSibling.value;

            [].slice.call(document.querySelectorAll('input')).forEach((input) => {
                if (input.value === currentInputValue) {
                    if (input.hasAttribute('data-titles')) {
                        input.remove();
                    }
                }
            });

            this.dogPrefixes = this.dogPrefixes.filter((title) => id !== title.id);
        },

        deleteSuffix(id, event) {
            const currentInputValue = event.target.previousElementSibling.value;

            [].slice.call(document.querySelectorAll('input')).forEach((input) => {
                if (input.value === currentInputValue) {
                    if (input.hasAttribute('data-suffixes')) {
                        input.remove();
                    }
                }
            });

            this.dogPreSuffixes = this.dogPreSuffixes.filter((suffix) => id !== suffix.id);
        },

        submitForm() {
            const form = document.querySelector('[data-step-two]');

            if (form) {
                form.submit();
            }
        }
    };
};

export default function titles() {
    window.dogTitles = dogTitles;
}



// WEBPACK FOOTER //
// ./resources/js/frontend/components/dogTitles.js